export default __webpack_public_path__ + "static/media/wault-icon.dbeebc20.png";